import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4308 3.6255C11.0727 2.32482 12.9274 2.32482 13.5693 3.6255L15.5258 7.58974C15.5622 7.66352 15.6326 7.71466 15.714 7.7265L20.0888 8.36219C21.5242 8.57076 22.0974 10.3347 21.0587 11.3472L17.8931 14.4329C17.8342 14.4903 17.8073 14.5731 17.8212 14.6542L18.5685 19.0113C18.8137 20.4409 17.3132 21.531 16.0293 20.8561L12.1164 18.7989C12.0436 18.7606 11.9566 18.7606 11.8837 18.7989L7.97079 20.8561C6.68694 21.531 5.18643 20.4409 5.43163 19.0113L6.17893 14.6542C6.19284 14.5731 6.16595 14.4903 6.10703 14.4329L2.9414 11.3472C1.90275 10.3347 2.47589 8.57077 3.91128 8.36219L8.28607 7.7265C8.36749 7.71466 8.43789 7.66352 8.4743 7.58974L10.4308 3.6255Z",
		fill: "#FFC933"
	})
});
export { SvgIconStarFilled as ReactComponent };
